import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex flex-row py-12px align-items-center" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "d-flex flex-col w-100 ps-3" };
const _hoisted_4 = { class: "d-flex flex-row w-100" };
const _hoisted_5 = { class: "d-flex flex-row gap-16px" };
import { onMounted, ref, watch } from "vue";
import axios from 'axios';
import StatusComponent from "../components/Status.vue";
import EditCampaign from '../pages/EditCampaign.vue';
import Vue3EasyDataTable from "vue3-easy-data-table";
import ButtonComponent from '../components/Button.vue';
import { useToast } from 'vue-toast-notification';
import "vue3-easy-data-table/dist/style.css";
import 'vue-toast-notification/dist/theme-sugar.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableCampaignExpired',
    props: {
        baseUrl: { type: String },
        token: { type: String },
        userRole: { type: String },
        router: { type: Object },
        languageJson: { type: Array },
    },
    emits: ["handleEdit"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const serverOptions = ref({
            page: 1,
            rowsPerPage: 15
        });
        const totalData = ref([]);
        const items = ref([]);
        const isLoading = ref(false);
        const getError = ref(null);
        const totalItems = ref(0);
        const activeItem = ref('');
        const locked = ref(true);
        const $toast = useToast();
        const headers = [{
                text: "Titolo",
                value: "name",
                sortable: true,
                width: 400
            },
            {
                text: "Inizio campagna",
                value: "campaignStarts",
                sortable: false,
                width: 150
            },
            {
                text: "Fine campagna",
                value: "campaignEnds",
                sortable: false,
                width: 150
            },
            {
                text: "Status",
                value: "status",
                sortable: false,
                width: 150
            }
        ];
        const showRow = (item) => {
            activeItem.value = item.ID;
        };
        const handleReturn = (item) => {
            activeItem.value = '';
        };
        const bodyRowClassNameFunction = (item) => {
            return 'clickable-row';
        };
        const bodyItemClassNameFunction = (column) => {
            if (column === 'score')
                return 'score-column';
            return '';
        };
        const headerItemClassNameFunction = (header) => {
            if (header.value === 'score')
                return 'score-column';
            return '';
        };
        const fetchData = async (activePage, orderBy = 'campaignStarts', orderDir = 'asc', name = "") => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1/private/campaigns`, {
                    params: {
                        page: activePage,
                        size: serverOptions.value.rowsPerPage,
                        name: name,
                        orderBy: orderBy,
                        orderDir: orderDir
                    },
                    headers: {
                        Authorization: `Bearer ${props.token}`
                    }
                });
                getError.value = null;
                totalData.value = response.data.results;
                totalItems.value = response.data.count;
                items.value = response.data.results
                    .filter(val => val.expired === true) // filtro lato client, parametro non disponibile nell'API
                    .map(val => ({
                    name: val.name,
                    campaignEnds: val.campaignEnds ? formatDateTime(val.campaignEnds) : '',
                    campaignStarts: val.campaignStarts ? formatDateTime(val.campaignStarts) : '',
                    status: val.status.name,
                    ID: val.uuid
                }));
            }
            catch (error) {
                getError.value = error;
                totalData.value = null;
                items.value = null;
            }
            finally {
                setTimeout(() => {
                    isLoading.value = false;
                }, 1000);
            }
        };
        function formatDateTime(isoString) {
            const date = new Date(isoString);
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
            };
            return new Intl.DateTimeFormat('it-IT', options).format(date).replace(',', '');
        }
        watch(serverOptions, (value) => { fetchData(serverOptions.value.page - 1); }, { deep: true });
        onMounted(() => {
            fetchData(0);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_unref(Vue3EasyDataTable), {
                        "server-options": serverOptions.value,
                        "onUpdate:serverOptions": _cache[0] || (_cache[0] = ($event) => ((serverOptions).value = $event)),
                        "server-items-length": totalItems.value,
                        headers: headers,
                        items: items.value,
                        "header-item-class-name": headerItemClassNameFunction,
                        "body-row-class-name": bodyRowClassNameFunction,
                        "body-item-class-name": bodyItemClassNameFunction,
                        "buttons-pagination": "",
                        loading: isLoading.value,
                        alternating: "",
                        "must-sort": "",
                        onClickRow: showRow,
                        "fixed-header": true
                    }, {
                        "item-status": _withCtx(({ status }) => [
                            _createElementVNode("div", {
                                class: _normalizeClass(["d-flex flex-row py-12px align-items-center", status === 'DRAFT' && 'evidence-disable'])
                            }, [
                                _createVNode(StatusComponent, {
                                    text: 'EXPIRED',
                                    type: status !== 'PUBLISHED' ? 'primary' : 'disable'
                                }, null, 8, ["type"])
                            ], 2)
                        ]),
                        "item-markedPath": _withCtx(({ markedPath }) => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(StatusComponent, {
                                    text: markedPath,
                                    type: markedPath === 'In evidenza' ? 'primary' : 'disable'
                                }, null, 8, ["text", "type"])
                            ])
                        ]),
                        _: 1
                    }, 8, ["server-options", "server-items-length", "items", "loading"])
                ], 512), [
                    [_vShow, !activeItem.value]
                ]),
                (activeItem.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(ButtonComponent, {
                                        text: 'Indietro',
                                        type: "regular",
                                        class: "bg-white",
                                        isDisable: isLoading.value || getError.value,
                                        onHandleClick: handleReturn
                                    }, null, 8, ["isDisable"])
                                ])
                            ])
                        ]),
                        (activeItem.value)
                            ? (_openBlock(), _createBlock(EditCampaign, {
                                key: activeItem.value,
                                baseUrl: props.baseUrl,
                                router: props.router,
                                languageJson: props.languageJson,
                                campaignId: activeItem.value,
                                locked: locked.value
                            }, null, 8, ["baseUrl", "router", "languageJson", "campaignId", "locked"]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
